import { MetaDataService } from "./implementations/metadata.service";
import { useStore } from "vuex";

export default defineNuxtPlugin((nuxtApp) => {
  const metadata = new MetaDataService(
    nuxtApp,
    nuxtApp.$axios,
    useStore(),
    nuxtApp.$config.public.sgCmsApi,
    nuxtApp.$config.public.frontEndUrl
  );

  return {
    provide: {
      metadata: metadata,
    },
  };
});